import appContext from './appContext.service';
import auth from './auth.service';
import billing from './billing.service';
import collection from './collection.service';
import configuration from './configuration.service';
import course from './course.service';
import email from './email.service';
import lernsets from './lernsets.service';
import notification from './notification.service';
import mindItem from './mindItem.service';
import product from './product.service';
import registration from './registration.service';
import text from './text.service';
import track from './track.service';
import user from './user.service';
import search from './search.service';
import ai from './ai.service';
import conversation from './conversation.service';
import pdf from './pdf.service';
import image from './image.service';

export default {
  appContext,
  ai,
  auth,
  billing,
  collection,
  configuration,
  course,
  email,
  lernsets,
  mindItem,
  notification,
  product,
  registration,
  text,
  track,
  user,
  search,
  conversation,
  pdf,
  image,
};
